import React, { useEffect, useState } from "react";
import Like from "./images/thumbsup.png";
import Dislike from "./images/thumbsdown.png";
import NoFeedbackIcon from "./images/nofeedback.png";
import "./Styling.css";
import Duration from "./images/duration.png";

const FeedbackStatistics = ({ total_questions, feedback_count }) => {
  const [showIcon, setShowIcon] = useState(false);

  const positiveLiked = feedback_count?.liked_count || 0;
  const negativeLiked = feedback_count?.disliked_count || 0;

  const [feedbackData, setFeedbackData] = useState({
    positive: positiveLiked,
    negative: negativeLiked,
    noFeedback: total_questions - (positiveLiked + negativeLiked),
    totalQuestions: total_questions,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const calculatePercentage = (value) => {
    return feedbackData.totalQuestions > 0
      ? (value / feedbackData.totalQuestions) * 100
      : 0;
  };
  const positivePercent = calculatePercentage(feedbackData.positive);
  const negativePercent = calculatePercentage(feedbackData.negative);
  const neutralPercent = calculatePercentage(feedbackData.noFeedback);

  useEffect(() => {
    const storedStart = localStorage.getItem("startDate");
    const storedEnd = localStorage.getItem("endDate");

    if (!storedStart || !storedEnd) {
      setShowIcon(false);
      return;
    }

    const startDate = new Date(storedStart);
    const endDate = new Date(storedEnd);

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const isDefaultStart =
      startDate.getFullYear() === firstDayOfMonth.getFullYear() &&
      startDate.getMonth() === firstDayOfMonth.getMonth() &&
      startDate.getDate() === firstDayOfMonth.getDate();

    const isDefaultEnd =
      endDate.getFullYear() === today.getFullYear() &&
      endDate.getMonth() === today.getMonth() &&
      endDate.getDate() === today.getDate();

    setShowIcon(!(isDefaultStart && isDefaultEnd));
  }, []);

  return (
    <div className="feedback-card">
      <h3 className="feedback-title">Feedback Statistics</h3>
      {showIcon && (
        <img src={Duration} alt="duration" className="duration-icon" />
      )}
      <div className="feedback-item">
        <div>
          <img className="feedback-icon" src={Like} alt="Thumbs Up" />
          <span className="feedback-label-title">Thumbs Up</span>
        </div>
        <div>
          <span className="feedback-percent">
            {positivePercent.toFixed(1)}%
          </span>
        </div>
      </div>
      <div className="feedback-bar">
        <div
          className="feedback-fill"
          style={{ width: `${positivePercent}%`, backgroundColor: "#22c55e" }}
        />
      </div>

      <div className="feedback-item">
        <div>
          <img className="feedback-icon" src={Dislike} alt="Thumbs Down" />
          <span className="feedback-label-title">Thumbs Down</span>
        </div>
        <div>
          <span className="feedback-percent">
            {negativePercent.toFixed(1)}%
          </span>
        </div>
      </div>
      <div className="feedback-bar">
        <div
          className="feedback-fill"
          style={{ width: `${negativePercent}%`, backgroundColor: "#ef4444" }}
        />
      </div>

      <div className="feedback-item">
        <div>
          <img
            className="feedback-icon"
            src={NoFeedbackIcon}
            alt="No Feedback"
          />
          <span className="feedback-label-title">No Feedback</span>
        </div>
        <div>
          <span className="feedback-percent">{neutralPercent.toFixed(1)}%</span>
        </div>
      </div>
      <div className="feedback-bar">
        <div
          className="feedback-fill"
          style={{ width: `${neutralPercent}%`, backgroundColor: "#6b7280" }}
        />
      </div>

      <p className="feedback-note">
        Based on feedback from {feedbackData.totalQuestions} questions
      </p>
    </div>
  );
};

export default FeedbackStatistics;
